export const features = [
  "Extensive product recommendations",
  "Dozens of facelifting techniques",
  "Skin analysis by smart face scanner",
  "Dermatology approved skin guidance",
  "Visibly improve your skin quality",
];

export const genders = ["Female", "Male", "Non-binary"];

export const years = ["Under 25", "25-34", "35-44", "45-60", "Over 60"];

export const skinConcerns = [
  "Pimples or acne",
  "Enlarged pores",
  "Redness or rosacea",
  "Dullness",
  "Rough skin texture",
  "Uneven skin tone",
  "Hyperpigmentation",
  "Fine lines and wrinkles",
  "Nothing from above",
];

export const skinTypes = [
  {
    title: "Dry skin type",
    descr: "Lacks moisture, tends to feel tight, dull appearance, flakiness",
  },
  {
    title: "Normal skin type",
    descr:
      "Neither excessively oily nor overly dry, smoothtexture, small pores",
  },
  {
    title: "Oily skin type",
    descr:
      "Excess amount of sebum (oil), shiny, enlargedpores, prone to breakouts",
  },
  {
    title: "Combination skin type",
    descr: "T-zone (forehead, nose, and chin) oiliness,visible pores",
  },
];

export const dailySkinCare = [
  "Yes, I have a morning and an evening routine",
  "Only a morning one",
  "Only an evening one",
  "No, I don't have any routine",
];

export const skincareProductsUse = [
  "Cleanser",
  "Makeup Remover",
  "Toner",
  "Moisturizer",
  "Treatment(Eye)",
  "Treatment(Face)",
  "SPF",
  "Exfoliator",
  "None",
];

export const useSunscreen = [
  "Yes, always",
  "Yes, but only in sunny weather",
  "Sometimes",
  "Rarely",
  "Never",
];

export const usedSkincareSulfates = [
  "Yes, I’ve used them",
  "No, I avoid them",
  "Unsure if my products have them",
];

export const tiredSkincareWithAntioxidants = [
  "Yes, I’ve used them",
  "No, but willing to try",
  "Unsure if used them",
];

export const usedSkincareAcids = [
  "Yes, I’ve used them",
  "No, but open to it",
  "Unsure if used them",
  "I don't want to use acids",
];

export const benefitsOfRetinolAndVitamin = [
  "Yes, I've used them",
  "No, but interested",
  "Heard, but unsure",
];

export const additionalConcerns = [
  "Dryness",
  "Oiliness",
  "Textural Irregularities",
  "Puffy eyes",
  "Crow's feet",
  "Double chin",
  "Dark circles",
  "Sagging Skin",
];

export const moisturizedSkin = [
  "Yes",
  "Sometimes feel thighness",
  "No, can’t live without moisturizer",
  "I don’t know",
];

export const bothersYourSkin = [
  "Dull skin",
  "Tiny wrinkles",
  "Tightness",
  "Wants moisture all the time",
  "None of that",
];

export const isSensitiveSkin = [
  { title: "Sensitive", descr: "My skin often reacts badly. Redness, dryness and flakiness, itching and burning sensations." },
  { title: "Non-sensitive", descr: "My skin shows no reaction to certain ingredients or to changing skincare products." },
];

export const sleepHours = [
  "Minimal rest (less than 5 hours)",
  "I get some shut-eye (5-6 hours)",
  "I sleep long and well (7-8 hours)",
  "I like to sleep in (8+ hours)",
];

export const waterIntake = [
  " I only have coffee or tea",
  "About 2 glasses (16 oz.)",
  "2 to 6 glasses (16-48 oz.)",
  "More than 6 glasses",
];

export const stressLevel = ["Yes, everyday", "Often", "Rarely", "Never"];

export const skincareRoutineTime = [
  "10 minutes",
  "20 minutes",
  "30 minutes",
  "1 hour",
  "Even more",
];

export const improveWithSolvi = [
  "Knowledge of skincare",
  "Skincare consistency",
  "Skin health",
  "Self-care routine",
  "Skin confidence",
  "Other",
];

export const confidenceGoal = [
  "Confidently makeup-free",
  "Feel my best at events",
  "Feel more attractive in photos",
  "Enjoy compliments on my skin",
  "Take more selfies",
  "Other",
];

export const desiredFeeling = [
  "Better skincare choices",
  "Relaxed and stress-free",
  "Control my skincare",
  "Confident in my skin",
  "Radiant and glowing",
  "Other",
];

export const solviOutcome = [
  "Reduce acne, redness, or sensitivity",
  "Find the best skincare routine for my skin",
  "Learn skincare ingredients",
  "Save money on skincare",
  "Prevent early signs of aging",
  "Other",
];

export const marks = [1, 2, 3, 4, 5];

export const dataSecret = [
  {
    img_url: "/women1.png",
    description:
      "Use an ice roller to reduce redness,soothe skin, and shrink pores.",
    title: "Ice Roller",
    type: "Tip#1:",
  },
  {
    img_url: "/women2.png",
    description:
      "Start with an oil cleanser, then use a water-based cleanser for deep cleaning.",
    title: "Double Cleanse",
    type: "Tip#2:",
  },
  {
    img_url: "/women3.png",
    description:
      "Layer face toner for extra moisture and nourishment. The super effect isguaranteed!",
    title: "Hydrating Hack",
    type: "Tip#3:",
  },
  {
    img_url: "/women4.png",
    description:
      "Dab on tea tree oil or benzoyl peroxide before bed to target blemishes.",
    title: "Spot Treatment",
    type: "Tip#4:",
  },
];

export const dataReason = [
  { img_url: "/reason1.svg", title: "Professional medical board" },
  { img_url: "/reason2.svg", title: "AI that passed real medical exam" },
  {
    img_url: "/reason3.svg",
    title: "The AI product scanner crafted by expert chemists",
  },
  {
    img_url: "/reason4.svg",
    title: "Independent app not affiliated with any skincare brand",
  },
];

export const creamData = [
  {
    img_url: "/cream1.png",
    title: "Blue Peptides - Balsam do oczu i ust",
    percent: 97,
  },
  {
    img_url: "/cream2.png",
    title: "Ultralight Face Fluid SPF 30 - Ochrona przeciwsłoneczna",
    percent: 100,
  },
  {
    img_url: "/cream3.png",
    title: "Aquasource Hydra Barrier - Barierowy krem z bio-ceramidami",
    percent: 97,
  },
];

export const fakeData = [
  "wrf***@ 1-Month Plan",
  "par***@ 1-Month Plan",
  "wrf***@ 1-Month Plan",
  "par***@ 1-Month Plan",
];


export const steps = [
  "Identifying skin type...",
  "Reviewing Your Routine",
  "Generating Your Action Plan",
];

export const reviews = [
  {
    name: "TashaW91",
    rating: 5,
    title: "A little extra incentive",
    city: "Miami",
    date: "Sep 2025",
    text: `Honestly, I was already loving the results, but when I saw I could be rewarded with a beauty box just for being consistent, it pushed me to stay 100% on track.`,
  },
  {
    rating: 5,
  date: "Sep 2025",
  city: "Boston",
  name: "Ava_H20",
  title: "Incredible results!",
  text: "My skin has transformed in just a couple of months. I love how the app keeps me accountable and tracks everything."
  },
  {
    rating: 4,
    date: "Oct 2025",
    city: "Austin",
    name:"Mia_F34",
    title: "Must-have for skincare lovers",
    text: "This app is brilliant! It helped me build the perfect routine, and my skin has improved so much. Can’t recommend it enough."
  },
{
    rating: 4,
    date: "Sep 2025",
    city: "Denver",
    name: "Olivia.C",
    title: "Amazing for busy people",
    text: "As someone with a packed schedule, this app has been a lifesaver. It keeps me on track with my routine and simplifies everything."
},
{
  rating: 5,
  date: "Oct 2025",
  city: "Miami",
  name: "Riley_P33",
  title: "Love the progress tracking",
  text: "This app is super intuitive and user-friendly. I’ve seen such a huge improvement in my skin since starting to use it. Totally worth it!"
},
{
  rating: 5,
  date: "Sep 2025",
  city: "Los Angeles",
  name: "Sofia_R22",
  title: "Game changer for my routine",
  text: "I love how easy this app makes it to follow a skincare routine. The reminders and progress tracker are my favorite features. Highly recommend!"
}
];

export const pricingData = [
  {
    title: "1-Year Plan",
    price: "$129.99",
    priceWithDiscount: "$64.99",
    discount: "$65",
    beforPrice: "$0.36",
    nowPrice: "$0.18",
    price_id: "price_1SBXZUJM0DnG2MaAdXc3JzCu",
    // price_id: "price_1SBXbqJqJyyIEbrVicuxziVP",
    prod_id: "prod_T7n9HzTbqQEF8R",
    period: "annually",
    total: "$65 / year"
  },
  {
    title: "1-Month Plan",
    price: "$39.99",
    priceWithDiscount: "$19.99",
    discount: "$20",
    beforPrice: "$1.33",
    nowPrice: "$0.67",
    price_id: "price_1SBXYkJM0DnG2MaAF3q3ZWp0",
    // price_id: "price_1SBXcGJqJyyIEbrVO3CIIz6N",
    prod_id: "prod_T7n9tUizbeXymm",
    period: "monthly",
    total: "$20 / month"
  },
  {
    title: "3-Months Plan",
    price: "$59.99",
    priceWithDiscount: "$29.99",
    discount: "$30",
    beforPrice: "$0.67",
    nowPrice: "$0.33",
    price_id: "price_1SBXYAJM0DnG2MaAStfGglVy",
    // price_id: "price_1SBXceJqJyyIEbrVO4b0q87I",
    prod_id: "prod_T7n8ZXifi1Luv3",
    period: "every 3 months",
    total: "$30 / 3-months"
  },
];


export const messages = [
  {
    id: 1,
    delay: 0, // появится сразу
    className:
      "absolute w-[250px] px-3 py-2 top-[60px] left-5 z-20 bg-[#FC5EB2] rounded-tl-2xl rounded-bl-2xl rounded-br-2xl text-white",
    text: (
      <>
        Hi 👋 Let’s find the right skincare
        <br /> routine for you. Could you tell
        <br /> me what your skin type is?
      </>
    ),
  },
  {
    id: 2,
    delay: 2, // через 2 сек после первого
    className:
      "absolute top-[135px] left-[60px] z-20 bg-[#F4E0FF] w-[250px] px-3 py-2 rounded-tl-2xl rounded-bl-2xl rounded-br-2xl",
    text: (
      <>
        I have normal skin. I’d like to
        <br /> establish a beauty routine to
        <br /> take care of my face and
        <br /> improve its condition.
      </>
    ),
  },
  {
    id: 3,
    delay: 3, // через 4 сек после старта
    className:
      "absolute top-[230px] left-[10px] w-[300px] z-20 px-3 py-2 bg-[#FC5EB2] rounded-tl-2xl rounded-bl-2xl rounded-br-2xl text-white",
    text: (
      <>
        Perfect, I’ve got a few rituals for you that
        <br /> will work really well:
      </>
    ),
  },
];


export const categoriesItem = [
  { img: "/care.svg", title: "Care" },
  { img: "/body.svg", title: "Body" },
  { img: "/face.svg", title: "Face" },
  { img: "/aroma.svg", title: "Aroma" },
  { img: "/soul.svg", title: "Soul" },
  { img: "/hair.svg", title: "Hair" },
];